import React from 'react';

interface Props {
  children: React.ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('MiniApp error:', error, info);
  }

  handleReload = () => {
    this.setState({ error: null });
    window.location.reload();
  };

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-tg-bg text-tg-text">
          <h2 className="text-xl font-bold mb-2">Xatolik yuz berdi</h2>
          <p className="text-sm text-tg-hint mb-6 text-center">
            {this.state.error.message || 'Kutilmagan xatolik'}
          </p>
          <button
            onClick={this.handleReload}
            className="bg-tg-button text-white px-6 py-3 rounded-xl font-medium"
          >
            Qayta yuklash
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
